export default [
  {
    header: 'breadcrumb.configuration',
    resource: 'dashboard',
  },
  {
    title: 'breadcrumb.setting',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'breadcrumb.chatWidget',
        route: 'chat-widget',
        icon: '',
        resource: 'customize-chat-widget',
        action: 'read'
      },
      // {
      //   title: 'breadcrumb.integration',
      //   route: 'integration',
      //   icon: '',
      //   resource: 'merchant-integration',
      //   action: 'read'
      // },
      // {
      //   title: 'breadcrumb.businessInformation',
      //   route: 'business-information',
      //   icon: '',
      //   resource: 'modify-business-info',
      //   action: 'read'
      // },
      // {
      //   title: 'breadcrumb.bot',
      //   route: 'bot',
      //   icon: '',
      //   resource: 'customize-chat-widget',
      //   action: 'read'
      // },
    ],
  },
];